<ng-select
  [formControl]="languageControl"
  [items]="languages"
  [clearable]="false"
  [searchable]="false"
  [class.mobile]="isMobile"
/>
